import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./login";
import ForgotPassword from "./forgotpassword";
import ResetPassword from "./resetpassword";
import AppLayout from "./app/applayout";
import Home from "./app/home/home.js";
import Profile from "./app/profile";
import POS from "./app/pos/pos.js";
import Checklists from "./app/checklists";
import Tareas from "./app/tareas";
import Procedimientos from "./app/procedimientos.js";
import ProductWorkspace from "./app/commerce/ProductWorkspace";
import { PRODUCT_WORKSPACE_MODULES } from "./app/commerce/productWorkspaceAccess";
import Eventos from "./app/events/events.js";
import WebsiteInquiries from "./app/website-inquiries/WebsiteInquiries.js";
import WebsiteChat from "./app/website-chat/WebsiteChat.js";
import WebsiteChatConfig from "./app/website-chat/WebsiteChatConfig.js";
import MessagesHub from "./app/messages/MessagesHub.js";
import TableeHome from "./app/tablee/TableeHome.js";
import TableeLandings from "./app/tablee/TableeLandings.js";
import TableeCarousel from "./app/tablee/TableeCarousel.js";
import TableeDelivery from "./app/tablee/TableeDelivery.js";
import TableeGeneralConfig from "./app/tablee/TableeGeneralConfig.js";
import TableePaymentSettings from "./app/tablee/TableePaymentSettings.js";
import TableeMarketing from "./app/tablee/TableeMarketing.js";
import TableeEcommerceOrders from "./app/tablee/TableeEcommerceOrders.js";
import TableeShippingLabels from "./app/tablee/TableeShippingLabels.js";
import TableeCustomers from "./app/tablee/TableeCustomers.js";
import TableePromotions from "./app/tablee/TableePromotions.js";
import OlivaMarketing from "./app/oliva/OlivaMarketing.js";
import OlivaSales from "./app/oliva/OlivaSales.js";
import UsersAdmin from "./app/users-admin/UsersAdmin.js";
import CostControl from "./app/cost-control/CostControl";
import AuthWrapper from "./authwrapper"; // 🔹 Import it here
import ModuleAccess from "./moduleaccess";

const olivaCommerce = {
  apiPrefix: "/oliva-commerce", storeName: "Oliva y Miel", storeLogo: "/ovm_logo.png",
  storeUrl: "olivaymiel.cl", publicBaseUrl: process.env.REACT_APP_OLIVA_PUBLIC_BASE_URL || "https://olivaymiel.cl/tienda",
  labelsPath: "/app/oliva-etiquetas", ordersPath: "/app/oliva-ordenes",
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/app"
        element={
          <AuthWrapper>
            <AppLayout />
          </AuthWrapper>
        }
      >
        <Route path="home" element={<Home />} />
        <Route path="profile" element={<Profile />} />
        <Route path="pos" element={<ModuleAccess anyOf={["pos"]}><POS /></ModuleAccess>} />
        <Route path="checklists" element={<Checklists />} />
        <Route path="tareas" element={<Tareas />} />
        <Route path="procedimientos" element={<Procedimientos />} />
        <Route path="inventario" element={<ModuleAccess anyOf={["inventario", "inventory"]}><Navigate to="/app/commerce/products?tab=inventory" replace /></ModuleAccess>} />
        <Route path="eventos" element={<Eventos />} />
        <Route path="oliva-marketing" element={<OlivaMarketing />} />
        <Route path="oliva-ventas" element={<OlivaSales />} />
        <Route path="mensajes-sitio" element={<WebsiteInquiries />} />
        <Route path="mensajes-sitio/:id" element={<WebsiteInquiries />} />
        <Route path="mensajes" element={<MessagesHub />} />
        <Route path="mensajes/:id" element={<MessagesHub />} />
        <Route path="conversaciones" element={<WebsiteChat />} />
        <Route path="conversaciones/configuracion" element={<WebsiteChatConfig />} />
        <Route path="commerce/products" element={<ModuleAccess anyOf={PRODUCT_WORKSPACE_MODULES}><ProductWorkspace /></ModuleAccess>} />
        <Route path="tablee" element={<Navigate to="/app/commerce/products" replace />} />
        <Route path="oliva-ordenes" element={<ModuleAccess anyOf={["oliva_ecommerce_orders"]}><TableeEcommerceOrders key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-usuarios" element={<ModuleAccess anyOf={["oliva_customers"]}><TableeCustomers key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-despachos" element={<ModuleAccess anyOf={["oliva_delivery"]}><TableeDelivery key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-configuracion" element={<ModuleAccess anyOf={["oliva_general_config"]}><TableeGeneralConfig key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-pagos" element={<ModuleAccess anyOf={["oliva_payments", "oliva_general_config"]}><TableePaymentSettings key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-tienda-marketing" element={<ModuleAccess anyOf={["oliva_marketing"]}><TableeMarketing key="oliva-store-marketing" {...olivaCommerce} storefrontName={olivaCommerce.storeName} /></ModuleAccess>} />
        <Route path="oliva-tienda-campanas" element={<ModuleAccess anyOf={["oliva_general_config"]}><TableeLandings key="oliva-store-campaigns" {...olivaCommerce} storefrontName={olivaCommerce.storeName} /></ModuleAccess>} />
        <Route path="oliva-promociones" element={<ModuleAccess anyOf={["oliva_promotions"]}><TableePromotions key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="oliva-etiquetas/:orderId" element={<ModuleAccess anyOf={["oliva_ecommerce_orders"]}><TableeShippingLabels key="oliva-commerce" {...olivaCommerce} /></ModuleAccess>} />
        <Route path="tablee-inicio" element={<TableeHome />} />
        <Route path="tablee-landings" element={<TableeLandings />} />
        <Route path="tablee-carrusel" element={<TableeCarousel />} />
        <Route path="tablee-despachos" element={<TableeDelivery />} />
        <Route path="tablee-configuracion" element={<TableeGeneralConfig />} />
        <Route path="tablee-pagos" element={<ModuleAccess anyOf={["tablee_payments", "tablee_general_config", "configuración general"]}><TableePaymentSettings /></ModuleAccess>} />
        <Route path="tablee-marketing" element={<TableeMarketing />} />
        <Route path="tablee-ordenes" element={<TableeEcommerceOrders />} />
        <Route path="tablee-etiquetas/:orderId" element={<TableeShippingLabels />} />
        <Route path="tablee-usuarios" element={<TableeCustomers />} />
        <Route path="tablee-promociones" element={<TableePromotions />} />
        <Route path="usuarios" element={<UsersAdmin />} />
        <Route path="control-costos" element={<CostControl />} />
      </Route>
    </Routes>
  );
}

export default AppRouter;
